import { Box } from '@mui/material';
import SideNavContainer from '../../SideNav/SideNavContainer';
import styles from './SideNavLayout.module.scss';

import React from 'react';

export const SideNavLayoutComponent: React.FC<{
	children: React.ReactNode;
	isShowingSideNav: boolean;
}> = ( { children, isShowingSideNav } ) => (
	<Box className={ isShowingSideNav ? styles.root : undefined }>
		{ isShowingSideNav && (
			<Box className={ styles.sideNavWrap }>
				<SideNavContainer />
			</Box>
		) }
		<Box className={ styles.contentWrap }>{ children }</Box>
	</Box>
);
